import { socialIcons } from '../config/socialIcons.js';

export class FooterManager {
    constructor(app) {
        this.app = app;
        this.footer = null;
        this.socialContainer = null;
        this.subscribeContainer = null;
        this.isVisible = false;
        
        // Create the footer elements
        this.createFooter();
        
        // Initially hide the footer
        this.hide();
    }

    createFooter() {
        // Create main footer container
        this.footer = document.createElement('footer');
        this.footer.className = 'ethereal-footer';
        
        // Create social links container
        this.socialContainer = document.createElement('div');
        this.socialContainer.className = 'social-container';
        
        // Subscribe functionality temporarily removed
        this.subscribeContainer = document.createElement('div');
        this.subscribeContainer.className = 'footer-subscribe-container';
        
        // Add containers to footer
        this.footer.appendChild(this.socialContainer);
        // Subscribe button temporarily removed while fixing API implementation
        // this.footer.appendChild(this.subscribeContainer);
        
        // Add footer to document
        document.body.appendChild(this.footer);
    }

    addSocialLink(platform, url) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.className = 'social-link';
        link.setAttribute('data-platform', platform);
        
        // Create icon container
        const iconContainer = document.createElement('div');
        iconContainer.className = 'social-icon-container';
        
        if (socialIcons[platform]) {
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "16");
            svg.setAttribute("height", "16");
            svg.setAttribute("viewBox", socialIcons[platform].viewBox);
        
            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute("d", socialIcons[platform].path);
        
            svg.appendChild(path);
            iconContainer.appendChild(svg);
        }
        // Add platform name
        const platformName = document.createElement('span');
        platformName.className = 'platform-name';
        platformName.textContent = platform;
        
        // Assemble link
        link.appendChild(iconContainer);
        link.appendChild(platformName);
        
        // Add to social container
        this.socialContainer.appendChild(link);

    }

    show() {
        if (!this.isVisible) {
            this.footer.classList.add('visible');
            this.isVisible = true;
        }
    }

    hide() {
        if (this.isVisible) {
            this.footer.classList.remove('visible');
            this.isVisible = false;
        }
    }

    toggle() {
        if (this.isVisible) {
            this.hide();
        } else {
            this.show();
        }
    }
}
